import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import FileAttachment from '@material-ui/icons/Attachment';

const Attachments = ({ attachments }) => {
  return (
    <div className="row">
      <div className="box-header-outside">
        <div className="col-sm-12">
          <div className="header">
            <h2>Do pobrania</h2>
          </div>
        </div>
      </div>
      <div className="box">
        <div className="col-sm-12">
          <List dense={true}>
            {attachments.map((attachment, index) => (
              <ListItem button key={index} onClick={() => window.open(attachment.url, '_blank')}>
                <ListItemAvatar>
                  <Avatar>
                    <FileAttachment />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={attachment.fileName}
                />
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    </div>
  );
};

Attachments.propTypes = {
  attachments: PropTypes.array.isRequired,
};

export default Attachments;


// WEBPACK FOOTER //
// ./src/components/consultationSurveys/Attachments.js